export default __webpack_public_path__ + "static/370-3d2c97484d10436da9b555c6bea183d2.jpg";